<div class="detection-container ">

  <div class="row justify-content-md-center">
    <div class="col-12 col-md-8">
      <div i18n="detection|@@downloadImage" class="h3 font-weight-bold text-center dark">Télécharger une image pour
        lancer la détection
        automatique de
        dommages</div>
    </div>
  </div>

  <div class="row justify-content-md-center mr-auto ml-auto" style="max-width:400px">
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="imagedetection" (click)='change()' value="/detection/image" type="radio" name="type"
        [(ngModel)]="typeResult">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@imageDetection"
        for="imagedetection">Detection</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="imageclassification" (click)='change()' value="/classification/image" type="radio" name="type"
        [(ngModel)]="typeResult">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@imageClassification"
        for="imageclassification">Classification</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="remarketing" (click)='change()' value="/remarketing/" type="radio" name="type"
        [(ngModel)]="typeResult">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@remarketing"
        for="remarketing">Remarketing</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="read" (click)='change()' value="/read/" type="radio" name="type" [(ngModel)]="typeResult">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@read" for="read">Read</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="imageprocessing" (click)='change()' value="/remarketing/hide/plate" type="radio" name="type"
        [(ngModel)]="typeResult">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@imageProcessing"
        for="imageprocessing">hidePlate</label>
    </div>
  </div>


  <div class="row justify-content-md-center mr-auto ml-auto" style="max-width:410px">
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="local" (click)='change()' value="local" type="radio" name="api" [(ngModel)]="_imagesService.apiToUse">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@localApi" for="local">Api Local</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input id="online" (click)='change()' value="online" type="radio" name="api"
        [(ngModel)]="_imagesService.apiToUse">
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@onlineApi" for="online">Api Online</label>
    </div>
    <div class="col* mt-3 mr-auto ml-auto">
      <input class="tgl tgl-light" id="save" type="checkbox" [(ngModel)]="_imagesService.save" (click)='change()' />
      <label class="h5 font-weight-bold text-center dark" i18n="detection|@@save" for="save">Save</label>
    </div>
  </div>



  <div class="row justify-content-md-center">
    <div class="col-12 col-md-8">

      <div class="row justify-content-md-center mr-auto ml-auto">
        <div class="col-11 d-inline-flex mt-3">
          <input class="inputUrl" type="text" placeholder="Url : https://domaine.com/etc..." [(ngModel)]="url">
          <button type="button" *ngIf="url" class="btn btn-lg primary ml-2" (click)="validateUrl()"><span
              i18n="detection|@@validate">Valider</span></button>
          <div class="ml-1 d-flex" *ngIf="typeResult === '/detection/image'">
            <input class="inputUrl" style="width: 60px;" type="number" step='0.1' max='1' min='0.1'
              [(ngModel)]="_imagesService.score">
            <label class="h5 font-weight-bold text-center dark ml-1 mt-auto mb-auto " for="online">Score</label>
          </div>

        </div>

      </div>
      <div class="row justify-content-md-center mr-auto ml-auto">
        <div class="col-11 d-inline-flex mt-3">
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="removeBackground" type="checkbox"
              [(ngModel)]="_imagesService.removeBackground" (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@removeBackground"
              for="removeBackground">Remove Background</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="blurBackground" type="checkbox" [(ngModel)]="_imagesService.blurBackground"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@blurBackground"
              for="blurBackground">Blur Background</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="blurFace" type="checkbox" [(ngModel)]="_imagesService.blurFace"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@blurFace" for="blurFace">Blur
              Face</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="blurLogo" type="checkbox" [(ngModel)]="_imagesService.blurLogo"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@blurLogo" for="blurLogo">Blur
              Logo</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="sablurTextve" type="checkbox" [(ngModel)]="_imagesService.blurText"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@blurText" for="blurText">Blur
              Text</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/remarketing/'">
            <input class="tgl tgl-light" id="blurLicencePlate" type="checkbox"
              [(ngModel)]="_imagesService.blurLicencePlate" (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@blurLicencePlate"
              for="blurLicencePlate">Blur Licence Plate</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/read/'">
            <input class="tgl tgl-light" id="vin" type="checkbox" [(ngModel)]="_imagesService.vin" (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@vin" for="vin">Vin</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/read/'">
            <input class="tgl tgl-light" id="mileage" type="checkbox" [(ngModel)]="_imagesService.mileage"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@mileage" for="mileage">Mileage</label>
          </div>
          <div class="col* mt-3 mr-auto ml-auto" *ngIf="typeResult === '/read/'">
            <input class="tgl tgl-light" id="licencePlate" type="checkbox" [(ngModel)]="_imagesService.licencePlate"
              (click)='change()' />
            <label class="h5 font-weight-bold text-center dark" i18n="detection|@@licencePlate" for="licencePlate">Licence Plate</label>
          </div>
        </div>
        <div class="col-11 d-inline-flex mt-3" *ngIf="typeResult === '/remarketing/'">
          <input class="inputUrl" type="text" placeholder="Background image" [(ngModel)]="urlBackground">
        </div>
      </div>

      <div class="custom-dropzone detection-dropzone" [multiple]='false' ngx-dropzone [accept]="'image/*'"
        (change)="onSelect($event)">


        <ngx-dropzone-label style="width: 100%;">

          <div class="row p-0 m-0 justify-content-md-center">
            <div class="col-9 col-md-6 buttonSend">
              <div class="row justify-content-md-center">
                <div class="col-3">
                  <img *ngIf="load === false" src="../../assets/icon/upload-file.svg" alt="">
                  <img *ngIf="load === true" src="../../assets/images/spinner.gif" alt="">
                </div>
                <div class="col-9 center">
                  <p i18n="detection|@@downloadImageButton" class="h5 font-weight-bold">Télécharger une image</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row  p-0 m-0 justify-content-md-center">
            <div class="col-12 col-md-6">
              <p i18n="detection|@@dragImage" class="smallText dark">ou déposer un fichier.</p>
            </div>
          </div>
        </ngx-dropzone-label>

        <div class="centerAll">
          <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
            [removable]="true" (removed)="onRemove(f)">
            <!-- <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label> -->
          </ngx-dropzone-image-preview>
        </div>
      </div>

    </div>
  </div>




  <div class="row justify-content-md-center" *ngIf="result || resultClassification">

    <div class="col-12 col-md-8" *ngIf="typeResult == '/detection/image' && result">
      <div class="row justify-content-md-center mr-auto ml-auto">
        <div class="col-12 d-block d-md-none">
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityHeatmap">Opacité
              Heatmap</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityH" />
          </div>
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityParts">Opacité Parts</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityP" />
          </div>
        </div>
        <div class="col-12 col-md-12 canvasCol ">
          <app-canvas-detection [result]='result' [opacityH]='opacityH' [opacityP]='opacityP' [opacityC]='opacityC'>
          </app-canvas-detection>
        </div>
        <div class="col-md-4 d-none d-md-block">
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityHeatmap">Opacité
              Heatmap</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityH" />
          </div>
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityParts">Opacité Parts</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityP" />
          </div>
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityCar">Opacité Car</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityC" />
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-md-8">
          <label class="h5 font-weight-bold text-center dark" i18n="detection@@damageList">Damages List</label>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" readonly="readonly"
            [(ngModel)]="result.damages"></textarea>
        </div>
        <div class="col-12 col-md-8">
          <label class="h5 font-weight-bold text-center dark" i18n="detection@@partsList">Parts List</label>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="result.parts_data"
            readonly="readonly"></textarea>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8" *ngIf="typeResult == '/remarketing/removeBackground' || typeResult == '/remarketing/blur' && result">
      <div class="row justify-content-md-center mr-auto ml-auto">
        <div class="col-12 d-block d-md-none">
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityHeatmap">Opacité
              Heatmap</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityH" />
          </div>
          <div class="d-iblock px-3 mt-3">
            <label class="h5 font-weight-bold text-center dark" for="tweak-luminosité"
              i18n="detection|@@opacityParts">Opacité Parts</label>
            <input type="range" id="tweak-gamma" min="0" max="1" step="0.001" class="range slider-small"
              [(ngModel)]="opacityP" />
          </div>
        </div>
        <div class="col-12 col-md-8 canvasCol ">
          <app-canvas-imageprocessing [result]='result' [opacityH]='1' [opacityP]='1'
            [opacityC]='1'>
          </app-canvas-imageprocessing>
        </div>

      </div>
    </div>
    <div class="col-12 col-md-8" *ngIf="typeResult == '/read/vin' || typeResult == '/read/mileage' && result">
      <div class="col-12 col-md-8">
        <app-canvas-imageprocessing [result]='result' [opacityH]='opacityH' [opacityP]='opacityP'
        [opacityC]='opacityC'>
      </app-canvas-imageprocessing>
        <label class="h5 font-weight-bold text-center dark" i18n="detection@@damageList">Value</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" readonly="readonly"
          [(ngModel)]="result.damages"></textarea>
      </div>
    </div>

    <div class="col-12 col-md-8" *ngIf="typeResult === '/classification/image' && resultClassification">
      <div class="col-12 mb-4 p-0" *ngFor="let key of getData(resultClassification)">
        <span class='classificationHead'>{{key[0]}}</span>
        <div class="col-12" *ngFor="let array of  key[1]">
          {{array[0]}} : {{array[1].toFixed(2)}} %
          <div class="progress">
            <div class="progress-bar" role="progressbar" [ngStyle]="{'width.%': array[1]}" aria-valuenow="100"
              aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/detection/detection.component.html